import StarRateIcon from '@mui/icons-material/StarRate';
import { Avatar, Badge, Box, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import TransferButton from './TransferButton';
import UpdateOwnerButton from './UpdateOwnerButton';

const UserInfoCard = ({
  userId,
  displayName,
  pictureUrl,
  phonenumber,
  isOwner,
  onUpdateOwner,
  onTransferMember,
}) => {
  return (
    <Box>
      <ListItem
        alignItems="center"
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'auto minmax(0, 1fr)',
            md: 'auto minmax(0, 1fr) auto',
          },
          columnGap: '16px',
          rowGap: '8px',
          paddingLeft: '0',
          position: 'relative',
        }}
      >
        <ListItemAvatar sx={{ position: 'relative', cursor: 'pointer' }}>
          {pictureUrl ? (
            <Avatar src={pictureUrl} alt={displayName} sx={{ border: '1px solid #ddd' }} />
          ) : (
            <Avatar />
          )}

          {isOwner && (
            <Badge
              color="primary"
              sx={{
                position: 'absolute',
                top: '-10px',
                right: '10px',
              }}
            >
              <StarRateIcon sx={{ color: '#FFC93C' }} />
            </Badge>
          )}
        </ListItemAvatar>
        <ListItemText
          sx={{ minWidth: 0 }}
          primary={displayName ? displayName : `Unknown ${userId}`}
          primaryTypographyProps={{
            sx: {
              fontSize: '1.5rem',
              lineHeight: '1.5rem',
              cursor: 'pointer',
            },
          }}
          secondary={phonenumber || ''}
          secondaryTypographyProps={{
            sx: {
              fontSize: '1.5rem',
              lineHeight: '1.35rem',
            },
          }}
        />
        <Box
          sx={{
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
            gridColumn: { xs: '1 / -1', md: '3 / 4' },
            gridRow: { xs: '2 / 3', md: '1 / 2' },
            justifyContent: { xs: 'flex-start', md: 'flex-end' },
          }}
        >
          {!isOwner && <UpdateOwnerButton onClick={onUpdateOwner} />}
          <TransferButton onClick={onTransferMember} />
        </Box>
      </ListItem>
    </Box>
  );
};
export default UserInfoCard;
